import { useCallback } from 'react'
import { useAIHelpContext } from '@context'

/**
 * Opens the Ask Luca sheet and queues `message` for the embedded widget
 * (same send path as a welcome-prompt click once the iframe receives it).
 */
export const useOpenLucaWithPrompt = () => {
  const { setAIHelpOpen, setPendingLucaPrompt } = useAIHelpContext()

  return useCallback(
    (message: string) => {
      const trimmed = message.trim()
      if (!trimmed) return
      setPendingLucaPrompt(trimmed)
      setAIHelpOpen(true)
    },
    [setAIHelpOpen, setPendingLucaPrompt]
  )
}
